document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const mobileButton = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileButton && mobileNav) {
    mobileButton.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      mobileButton.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
    });
  }

  const overlay = document.querySelector('[data-drawer-overlay]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const allDrawers = [searchDrawer, cartDrawer].filter(Boolean);

  const closeDrawers = () => {
    allDrawers.forEach((drawer) => {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('drawer-open');
  };

  const openDrawer = (drawer) => {
    closeDrawers();
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('drawer-open');
    const input = drawer.querySelector('input');
    if (input) setTimeout(() => input.focus(), 200);
  };

  document.querySelector('[data-open-search]')?.addEventListener('click', () => openDrawer(searchDrawer));
  document.querySelector('[data-open-cart]')?.addEventListener('click', () => openDrawer(cartDrawer));
  document.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawers));
  overlay?.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawers(); });

  document.querySelectorAll('[data-quick-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: Number(button.dataset.variant), quantity: 1}]})
        });
        if (!response.ok) throw new Error('Unable to add item');
        button.textContent = 'Added ✓';
        setTimeout(() => window.location.href = '/cart', 450);
      } catch (error) {
        button.textContent = 'View options';
        window.location.href = button.dataset.url;
      } finally {
        setTimeout(() => { button.disabled = false; button.textContent = originalText; }, 1800);
      }
    });
  });
});

// Product media gallery
const initProductGalleries = () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-product-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    if (slides.length < 1) return;

    let activeIndex = 0;

    const showSlide = (requestedIndex, focusThumb = false) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });
      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        if (isActive) {
          thumb.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
          if (focusThumb) thumb.focus();
        }
      });
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    prev?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.index)));
      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(activeIndex + 1, true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(activeIndex - 1, true); }
      });
    });

    let touchStartX = 0;
    gallery.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, {passive: true});
    gallery.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      showSlide(distance < 0 ? activeIndex + 1 : activeIndex - 1);
    }, {passive: true});
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGalleries);
} else {
  initProductGalleries();
}
